<template>
    <div class="name-select-table mt20">
        <KvTable :items="items"/>
    </div>
</template>
<script>
import KvTable from '../../../../Table/kvTable/index'

export default {
  components: {
    KvTable
  },
  props: ['refinedPatientListProps'],
  data() {
    const item = [
      {
        index: 0,
        keyTitle: this.$t('patients.name'),
        keyType: 'SelectBox',
        class: '',
        keyRange: this.refinedPatientListProps,
        values: ''
      }
    ];
    return {
      items: item
    }
  },
  methods: {
    getValue() {
      return this.items[0].values?.seqMedicalRelation;
    }
  }
}
</script>
<style lang="scss">
.name-select-table {
  width: 103%;
  height: 50px;

  .table-container {
    grid-template-rows: 50px !important;
    height: 50px;

    .item-value {
      width: 337px;
    }

    .modal .popup_title {
      overflow: unset !important;
      margin-bottom: 0px;
      height: 50px;

      .md_content {
        padding: 70px 40px 40px 40px !important;
      }
    }
  }
}
</style>